import {
	GET_PLACES,
	SET_PACKAGE,
	GET_GENEROS,
	GET_SERVICES,
	GET_PACKAGE,
	SAVE_PACKAGE
} from './Types';

export const getPlaces = () => { return { type: GET_PLACES } };
export const setPackage = obj => { return { type: SET_PACKAGE, payload: obj } };
export const getGeneros = () => { return { type: GET_GENEROS } };
export const getServices = () => { return { type: GET_SERVICES } };
export const getPackage = () => { return { type: GET_PACKAGE } };
export const savePackage = () => { return { type: SAVE_PACKAGE } };


// WEBPACK FOOTER //
// ./src/actions/PackageActions.js